import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { Observable } from "rxjs";

export const PROFILE_ACTION: string = "ProfileActionChannel";

export interface IProfileActionService {
  updateProfile(
    profileSettings: Array<CubiqTS.ProfileSettingImpl>,
    isUserSettings: boolean,
  ): Promise<void>;

  getProfileConfig(profileSettingKey: string): Promise<string>;

  getProfileConfigUpdates(profileSettingKey: string): Observable<string>;

  getProfileSettings(): Promise<any>;

  createUserSettingsProfileUpdateRequest(): Promise<CubiqTS.ProfileUpdateRequestImpl>;
}
